import React, { useState } from 'react';
import { EvidenceCard } from '../components/evidence/EvidenceCard';
import { ApprenticeSelector } from '../components/apprentices/ApprenticeSelector';

// Who can correct an entry after it's been submitted: the apprentice who wrote it,
// and the staff who assess it. Supervisors stay read-only, same as the review queue.
const STAFF_EDITORS = ['trainer', 'employer'];

export function EvidenceLogPage({ profile, evidence, myApprentices, selApprId, setSelApprId, getUnitName, onAddEvidence, onEditDraft, onEditEvidence, onDeleteEvidence, onLightbox, onPDF }) {
  const [filter, setFilter] = useState('all');
  const isApprentice = profile.role === 'apprentice';
  const canEdit = isApprentice || STAFF_EDITORS.includes(profile.role);
  const activeId = isApprentice ? profile.id : selApprId;
  const myEv = evidence.filter(e => e.apprentice_id === activeId);
  const drafts = myEv.filter(e => e.status === 'draft');
  const nonDrafts = myEv.filter(e => e.status !== 'draft');
  const filtered = filter === 'all' ? nonDrafts : nonDrafts.filter(e => e.status === filter);

  return (
    <div>
      <div className="page-hdr">
        <div>
          <div className="page-title">Evidence Log</div>
          <div className="page-sub">{filtered.length} entr{filtered.length === 1 ? 'y' : 'ies'}{drafts.length > 0 ? ` · ${drafts.length} draft${drafts.length !== 1 ? 's' : ''}` : ''}</div>
        </div>
        {isApprentice && (
          <button className="btn" onClick={onAddEvidence}>+ Log Evidence</button>
        )}
      </div>

      {!isApprentice && (
        <ApprenticeSelector apprentices={myApprentices} active={selApprId} onChange={setSelApprId} />
      )}

      {/* Draft banner — only visible to apprentices with drafts */}
      {isApprentice && drafts.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--muted)', letterSpacing: 0.5, marginBottom: 8 }}>DRAFTS</div>
          {drafts.map(d => (
            <div key={d.id} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '10px 14px', marginBottom: 8, borderRadius: 6,
              background: 'rgba(107,122,153,.06)', border: '1px dashed rgba(107,122,153,.3)',
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--head)' }}>
                  {d.job_number ? `Job #${d.job_number}` : 'Untitled draft'}
                  {d.vehicle_rego ? ` · ${d.vehicle_rego}` : ''}
                  <span className="badge draft" style={{ marginLeft: 8 }}>Draft</span>
                </div>
                <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                  {d.date || 'No date'}{d.fault_reason ? ` — ${d.fault_reason.slice(0, 60)}${d.fault_reason.length > 60 ? '…' : ''}` : ''}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn-sm" style={{ fontSize: 11, padding: '4px 12px' }} onClick={() => onEditDraft(d)}>
                  Continue editing →
                </button>
                <button
                  className="btn-sm"
                  style={{ fontSize: 11, padding: '4px 8px', color: 'var(--red)', borderColor: 'rgba(192,57,43,.3)' }}
                  onClick={() => onDeleteEvidence(d.id)}
                >
                  ✕
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 18, flexWrap: 'wrap' }}>
        {['all', 'pending', 'approved', 'rejected'].map(f => (
          <button key={f} className={`atab${filter === f ? ' on' : ''}`} onClick={() => setFilter(f)}>
            {f === 'all' ? 'All' : f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="empty">
          <div className="empty-icon">📋</div>
          <p>No evidence entries {filter !== 'all' ? `with status "${filter}"` : 'yet'}.</p>
        </div>
      ) : (
        filtered.map(e => (
          <EvidenceCard
            key={e.id}
            entry={e}
            unitLookup={getUnitName}
            onLightbox={onLightbox}
            onDelete={onDeleteEvidence}
            onEdit={onEditEvidence}
            onPDF={onPDF}
            collapsible
            canDelete={isApprentice}
            canEdit={canEdit}
            resubmitOnEdit={isApprentice}
          />
        ))
      )}
    </div>
  );
}
